import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SignupUserService } from '@app/modules/signup-new/services/signup-user.service';

@Component({ selector: 'sbnb-signup-restricted-page', templateUrl: './signup-restricted-page.component.html' })
export class SignupRestrictedPageComponent implements OnInit {
  constructor(
    public signupUserService: SignupUserService,
    private router: Router
  ) {}

  ngOnInit() {
    if (!this.signupUserService.user$.value || this.signupUserService.user$.value.status !== 'login_restricted') {
      this.router.navigate(['/signup']);
    }
  }
}
